import { render, staticRenderFns } from "./Window.vue?vue&type=template&id=215d3e1d"
import script from "./Window.vue?vue&type=script&lang=js"
export * from "./Window.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports